window.global = window.global ? window.global : window;
